import React, { useState, useEffect } from "react";
import { LoopCircleLoading } from "react-loadingg";
import Grid from "@mui/material/Grid";
import Character from "../components/Character";
import Message from "../components/Message";

const UpcomingCharactersList = () => {
  const [characters, setCharacters] = useState([]);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    fetch("https://revived-witch-api.herokuapp.com/api/characters/unreleased")
      .then((res) => res.json())
      .then(
        (result) => {
          setIsLoaded(true);

          setCharacters(result.upcomingCharacters);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  }, []);

  if (error) {
    return <>{error.message}</>;
  } else if (!isLoaded) {
    return <div style={{height: "50vh", weight:"50%"}}><LoopCircleLoading /></div>;
  } else {
    return (
      <>
        <Message
          title="About"
          message="This Is NOT Definitive Data, All Depends On Yostar,It Can Change without warning. Many Thanks To Reddit User Noctiee For The Information"
          severity="error"
        />
        <Grid container spacing={1} style={{ marginBottom: 30, marginTop: 30 }}>
          {characters.map((char, index) => (
            <>
              <Grid item xs={6} md={2} style={{ display: "flex" }} key={index}>
                <Character key={char._id} data={char} />
              </Grid>
            </>
          ))}
        </Grid>
      </>
    );
  }
};

export default UpcomingCharactersList;
